var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ChartLayout',{attrs:{"title":_vm.title,"units":_vm.units,"half":_vm.half},scopedSlots:_vm._u([(_vm.note)?{key:"notes",fn:function(){return [_c('p',[_vm._v(_vm._s(_vm.note))])]},proxy:true}:null],null,true)},[_c('DataGetter',{style:({ position: 'relative' }),attrs:{"url":_vm.apiRoute,"params":_vm.params},scopedSlots:_vm._u([{key:"default",fn:function({ data }){return [_c('DataSlicer',{attrs:{"data":data,"x-axis-dimension":"category","y-axis-dimension":"techSector","value-dimension":"value"},scopedSlots:_vm._u([{key:"default",fn:function({ slicedData }){return [_c('Chart',{attrs:{"options":{
            ..._vm.chartOptions,
            series: slicedData.map((series, i) => ({
              ...series,
              colorIndex: i === 0 ? 5 : 1,
              data: series.data
                .map((row) => [...row])
                .sort(
                  (a, b) =>
                    _vm.categoryOrder.indexOf(a[0]) - _vm.categoryOrder.indexOf(b[0])
                ),
            })),
          }}})]}}],null,true)})]}}])})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }